

































































































import {
  BSidebar,
  BForm,
  BButton,
  BCard,
  BCol,
  BFormCheckbox,
  BDropdown,
  BFormGroup,
  BDropdownItem,
  BFormInput,
  BPagination,
  BFormSelect,
  BRow,
  BTable,
  BSpinner,
} from "bootstrap-vue";
import { Component, Prop, Vue } from "vue-property-decorator";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import { Competence, UpdateCompetenceModel } from "@/api/models/competences/competence";
import SearchableVueSelect from "@/components/selects/SearchableVueSelect.vue";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";
import VueSlider from "vue-slider-component";
import 'vue-slider-component/theme/default.css';
import { MembreCompetence } from "@/api/models/membresCompetences/membreCompetence";

@Component({
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BFormInput,
    BTable,
    BPagination,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BSidebar,
    BForm,
    BFormGroup,
    BFormCheckbox,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    SearchableVueSelect,
    VueSlider
  },
  name: "update-competence",
})
export default class EditCompetence extends Vue {
  @Prop({ required: true, type: Boolean }) isUpdateMembreSidebarActive!: boolean;
  @Prop({ required: true }) membreId!: string;

  loading = false;
  required = required;
  loadingCompetence = false;

  direction = "ltr";
  optionCategorie = ['Titulaire', 'Remplacant'];

  membre: MembreCompetence = {};

  async created() {
    await this.$http.myressif.competences
      .getByMembreId(this.$route.params.id, this.membreId)
      .then((res: MembreCompetence) => {
        this.membre = res;
      });
  }

  resetForm() {
    this.membre = {};
  }

  async submit() {
    this.loading = true;
    await this.$http.myressif.competences
      .updateMembre(
        this.$route.params.id,
        this.membreId,
        this.membre
      )
      .then(
        async (response: any) => {
          successAlert.fire({
            timer: 3500,
            title: "Modification du membre",
            text: "Membre modifiée avec succès",
          });
        },
        (error: any) => {
          if (
            error?.response?.data?.errors &&
            Object.keys(error.response.data.errors).length
          ) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error?.response?.data?.detail ?? error.message,
            });
          }
        }
      )
      .finally(() => {
        this.$emit("refresh-membre-competences");
        this.$emit("update:is-update-membre-sidebar-active", false);
        this.loading = false;
      });
  }
}
